import "./App.css";
import NotFound from "./pages/NotFound/NotFound";
import Home from "./pages/pk/home";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import NewEvents from "./pages/NewEvents/home";
import Benefit from "./pages/benefit/home";
import CP from "./pages/cp/home";
import MostCharger from "./pages/most-charger/home";

function App() {
  const { i18n } = useTranslation(); // i18n to change language
  const urlParams = new URLSearchParams(window.location.search);

  // Extract the token from the query parameters
  const event = urlParams.get("event_type");
  return (
    <div>
      <Router>
        <Routes>
          {event == "pk" ? (
            <Route path="/" element={<Home />} />
          ) : event == "Weekly_star" ? (
            <Route path="/" element={<NewEvents />} />
          ) : event == "charge_benefits" ? (
            <Route path="/" element={<Benefit />} />
          ) : event == "most_charger" ? (
            <Route path="/" element={<MostCharger />} />
          ) : event == "cp" ? (
            <Route path="/" element={<CP />} />
          ) : (
            <Route path="/" element={<NotFound />} />
          )}
          <Route path="/charge_benefits" element={<Benefit />} />
          <Route path="/cp" element={<CP />} />
          <Route path="/new-events" element={<NewEvents />} />
          <Route path="*" element={<NotFound />} /> {/* Catch-all for 404 */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
